export default {
  1: "var(--radius-1)",
  2: "var(--radius-2)",
  3: "var(--radius-3)",
  4: "var(--radius-4)",
  5: "var(--radius-5)",
  6: "var(--radius-6)",
  "1-max": "var(--radius-1-max)",
  "2-max": "var(--radius-2-max)",
  "3-max": "var(--radius-3-max)",
  "4-max": "var(--radius-4-max)",
  "5-max": "var(--radius-5-max)",
  "6-max": "var(--radius-6-max)",
  full: "var(--radius-full)",
  "ra-1": "var(--ra-radius-1)",
  "ra-2": "var(--ra-radius-2)",
  "ra-3": "var(--ra-radius-3)",
  "ra-4": "var(--ra-radius-4)",
  "ra-5": "var(--ra-radius-5)",
  "ra-6": "var(--ra-radius-6)",
  "ra-1-max": "var(--ra-radius-1-max)",
  "ra-2-max": "var(--ra-radius-2-max)",
  "ra-3-max": "var(--ra-radius-3-max)",
  "ra-4-max": "var(--ra-radius-4-max)",
  "ra-5-max": "var(--ra-radius-5-max)",
  "ra-6-max": "var(--ra-radius-6-max)",
  "ra-full": "var(--ra-radius-full)",
};
